module.exports = __webpack_public_path__ + "img/m-kucunguanli.23971a3a.svg";